<script lang="ts" setup>
const localePath = useLocalePath()
const route = useRoute()

const currentLabel = computed(() => {
  const lastSegment = route.path.split('/').findLast(Boolean) ?? ''
  if (!lastSegment) return ''
  return lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).replace(/-/g, ' ')
})

const crumbs = computed(() => [
  { label: 'Home', to: localePath('/') },
  { label: currentLabel.value },
])
</script>

<template>
  <section class="page-hero">
    <div class="inner">
      <Breadcrumb :items="crumbs" />
      <div class="hero-content">
        <slot />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-hero {
  position: relative;
  padding: 56px 20px 24px;

  // Soft glow anchored behind the title that spills below the hero into the content.
  // It sits behind everything (z-index -1), so it never covers the text.
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 560px;
    background: radial-gradient(600px 560px at 25% 130px, rgba(227, 77, 92, 0.2), transparent 70%);
    z-index: -1;
    pointer-events: none;
  }
}

.inner {
  max-width: 1000px;
  margin: auto;
}

.hero-content {
  :deep(h1) {
    font-size: clamp(34px, 6vw, 60px);
    margin-top: 0;
    margin-bottom: 0.9em;
    line-height: 1.15;
  }

  :deep(p) {
    color: var(--text-subtle);
    font-size: 1.15em;
    max-width: 520px;
    margin: 0;
    line-height: 1.6;
  }
}
</style>
